module.exports = __webpack_public_path__ + "img/gh.343e618a.svg";